// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/shotlist/v1/vision_prop.proto (package protos.vision.shotlist.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/shotlist/v1/vision_prop.proto.
 */
export const file_vision_shotlist_v1_vision_prop: GenFile = /*@__PURE__*/
  fileDesc("CiR2aXNpb24vc2hvdGxpc3QvdjEvdmlzaW9uX3Byb3AucHJvdG8SGXByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEiiwEKClZpc2lvblByb3ASDwoHcHJvcF9pZBgBIAEoCRIMCgRuYW1lGAIgASgJEi4KCmNyZWF0ZWRfYXQYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi4KCnVwZGF0ZWRfYXQYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * @generated from message protos.vision.shotlist.v1.VisionProp
 */
export type VisionProp = Message<"protos.vision.shotlist.v1.VisionProp"> & {
  /**
   * @generated from field: string prop_id = 1;
   */
  propId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 3;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.VisionProp.
 * Use `create(VisionPropSchema)` to create a new message.
 */
export const VisionPropSchema: GenMessage<VisionProp> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_vision_prop, 0);

